import { render, staticRenderFns } from "./CookiesSettings.vue?vue&type=template&id=0c71b6ce&"
import script from "./CookiesSettings.vue?vue&type=script&lang=js&"
export * from "./CookiesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports